'use strict';

var scrollAnimate = require('core/components/scrollAnimate');
var recaptcha = require('core/components/recaptcha');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
var messageTimers = { status: null, error: null };

function displayMessage(success, msg) {
    var key = success ? 'status' : 'error';
    var $region = $('.email-signup-message-' + key);

    // Supersede within this region: cancel the previous message's pending timer and drop its
    // node before appending, so the region never holds two messages. With aria-atomic="true"
    // a second node would make a screen reader re-announce the stale text joined to the new.
    if (messageTimers[key]) {
        clearTimeout(messageTimers[key]);
        messageTimers[key] = null;
    }
    $region.empty().append(
        '<div class="email-signup-alert text-center alert ' + (success ? 'alert-success' : 'alert-danger') + '"'
        + (success ? '' : ' id="email-signup-error-msg"') + '>' + msg + '</div>'
    );
    messageTimers[key] = setTimeout(function () {
        $region.empty();
        messageTimers[key] = null;
    }, 3000);
}

/**
 * Light client-side phone validation. Permissive -- accepts digits, spaces,
 * parens, plus, hyphen; min 7 chars. Klaviyo normalises server-side, and
 * the existing 400-fallback in subscribeUser handles strict rejection.
 * @param {string} phone
 * @returns {boolean}
 */
function isValidPhone(phone) {
    return /^[\d\s()+\-]{7,}$/.test(phone || '');
}

var footer = {
    'elementNameMap': {
        'hpEmailSignUp': 'emailId',
        'phone': 'phone'
    },
    'backToTop': function () {
        $('.back-to-top').click(function () {
            scrollAnimate();
        });
    },
    'forms': 'footer .email-signup-form form',
    'init': function () {
        var nameMap = this.elementNameMap;

        // LEG-606: two live regions, created empty before any binding so they exist in the
        // accessibility tree before content lands. Two and not one: a successful subscribe must
        // not interrupt a screen reader the way an error legitimately does.
        // Both keep the existing `email-signup-message` class: that is what carries the toast
        // positioning (fixed, centred, above the page). Without it the message still reaches a
        // screen reader but a sighted shopper never sees it.
        if (!$('.email-signup-message-status').length) {
            $('body').append('<div class="email-signup-message email-signup-message-status" role="status" aria-live="polite" aria-atomic="true"></div>');
        }
        if (!$('.email-signup-message-error').length) {
            $('body').append('<div class="email-signup-message email-signup-message-error" role="alert" aria-live="assertive" aria-atomic="true"></div>');
        }

        // Prevent Multi Form event collision
        var $forms = $(this.forms);
        $forms.each(function () {
            var $form = $(this);
            var $inputs = $form.find(':input:not(:disabled)');

            // === Spam guards init (LEG-561) ===========================
            // The form lives in a content asset, so CSRF token and honeypot
            // are rendered on the wrapper div and propagated into the form
            // here so they serialize on submit.
            var $wrapper = $form.closest('.email-signup-form');

            var csrfName = $wrapper.data('csrf-name');
            var csrfToken = $wrapper.data('csrf-token');
            if (csrfName && csrfToken && !$form.find('input[name="' + csrfName + '"]').length) {
                $('<input>', { type: 'hidden', name: csrfName, value: csrfToken }).appendTo($form);
            }

            // Honeypot is server-rendered in the wrapper (so naive HTML-only
            // bots see it on initial response). Move it into the form so it
            // serializes on submit; missing-field detection on the server
            // catches bots that POST without picking it up.
            var $honeypot = $wrapper.children('input[name="subject"]').first();
            if ($honeypot.length && !$form.find('input[name="subject"]').length) {
                $honeypot.appendTo($form);
            }

            $inputs = $form.find(':input:not(:disabled)');
            // ==========================================================

            // Update Form Name for SFRA compatibility
            if (nameMap) {
                $inputs.each(function () {
                    var $input = $(this);
                    var oldName = $input.attr('name');
                    var newName = oldName && nameMap[oldName];

                    if (newName) {
                        $input.attr('name', newName);
                    }
                });
            }

            $form.on('submit', function (e, urlOverride) {
                e.preventDefault();

                var $phoneInput = $form.find('input[name="phone"]');
                var phoneVal = $phoneInput.length ? ($phoneInput.val() || '').trim() : '';
                if (phoneVal && !isValidPhone(phoneVal)) {
                    displayMessage(false, 'Please enter a valid phone number.');
                    return;
                }

                // LEG-606: scoped to the email input on purpose. A form-wide checkValidity()
                // would report a malformed optional phone as an email error and make the phone
                // message above unreachable.
                var emailEl = $form.find('input[name="emailId"]')[0];
                if (emailEl && emailEl.checkValidity && !emailEl.checkValidity()) {
                    displayMessage(false, 'Please enter a valid email address.');
                    $(emailEl).attr('aria-invalid', 'true').attr('aria-describedby', 'email-signup-error-msg');
                    $(emailEl).one('input', function () { $(this).removeAttr('aria-invalid').removeAttr('aria-describedby'); });
                    emailEl.focus();
                    return;
                }

                // LEG-606: the button, not the form. `disabled` on a <form> is a no-op the
                // browser ignores, so the double-submit guard never engaged.
                var $btn = $form.find('.subscribe-email');
                var xhr = $form.data('xhr');
                $btn.attr('disabled', true);
                $.spinner().start();

                recaptcha.check(
                    e,
                    {
                        url: urlOverride || $form.attr('action'),
                        type: $form.attr('method') || 'post',
                        data: $inputs.serialize(),
                        dataType: 'json',
                        beforeSend: function () {
                            // Drop duplicate requests
                            xhr && xhr.abort && xhr.abort();
                        },
                        success: function (data) {
                            displayMessage(data.success, data.msg);
                            if (data.success) {
                                $form[0].reset();   // LEG-606: only on a confirmed success, so an
                            }                       // error keeps what the shopper typed.
                            $form.trigger('footer:signup:success', data);
                        },
                        error: function ($xhr, err, other) {
                            // Guard failures (CSRF-AjaxFail / Recaptcha-AjaxFail)
                            // return {csrfError|recaptchaError, redirectUrl} with
                            // no .message -> fall back to a generic string so the
                            // toast never renders "undefined". Kept generic on
                            // purpose: bots must not learn which guard fired.
                            var msg = ($xhr.responseJSON && $xhr.responseJSON.message)
                                || 'Unable to sign up right now. Please try again.';
                            displayMessage(false, msg);
                        },
                        complete: function () {
                            // LEG-606: no reset here. This fires on transport errors too and gets
                            // no parsed body, so it cannot tell a rejection from a success; the
                            // reset moved into success: gated on the payload.
                            $.spinner().stop();
                            $btn.removeAttr('disabled');
                        }
                    },
                    function (data) {
                        $form.data('xhr', $.ajax(data));
                    },
                    function(data, error) {
                        $.spinner().stop();
                        $btn.removeAttr('disabled');
                        $form[0].reset();
                }
                );
            })

            // For SFRA compatibility
            $form.find('.subscribe-email').on('click', function (e) {
                e.preventDefault();
                $form.trigger('submit', $(this).data('href'));
            });
        });
    }
};

module.exports = footer;
